import * as tslib_1 from "tslib";
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { filter, tap } from 'rxjs/operators';
import { CrudApiService } from '@ml/shared/services/crud-api.service';
import { QueryParams } from '@ml/shared/types/query-params';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CommentsService = /** @class */ (function (_super) {
    tslib_1.__extends(CommentsService, _super);
    function CommentsService(http) {
        var _this = _super.call(this, http, true) || this;
        _this.http = http;
        _this.resourceId$ = new BehaviorSubject(null);
        _this.resource$ = new BehaviorSubject(null);
        _this.title$ = new BehaviorSubject(null);
        _this.commentAdded = new BehaviorSubject(null);
        _this.commentRemoved = new BehaviorSubject(null);
        return _this;
    }
    Object.defineProperty(CommentsService.prototype, "url", {
        get: function () {
            return this.resource$.value + "/" + this.resourceId$.value + "/comments";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommentsService.prototype, "title", {
        get: function () {
            return this.title$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    CommentsService.prototype.subscribeValues$ = function () {
        return _super.prototype.subscribeValues$.call(this);
    };
    CommentsService.prototype.setDetails = function (resource, resourceId, title) {
        this.resource$.next(resource);
        this.resourceId$.next(resourceId);
        this.title$.next(title);
    };
    CommentsService.prototype.add = function (comment) {
        var _this = this;
        return _super.prototype.add.call(this, comment).pipe(tap(function () { return _this.onAddComment(); }));
    };
    CommentsService.prototype.delete = function (id) {
        var _this = this;
        return _super.prototype.delete.call(this, id).pipe(tap(function () { return _this.onRemoveComment(); }));
    };
    CommentsService.prototype.deleteUrl = function (id) {
        return "comments/" + id;
    };
    CommentsService.prototype.getInitialQueryParams = function () {
        var queryParams = new QueryParams();
        queryParams.pageSize = 15;
        return queryParams;
    };
    CommentsService.prototype.unsubscribeManageComments = function () {
        this.commentAdded = new BehaviorSubject(null);
        this.commentRemoved = new BehaviorSubject(null);
    };
    CommentsService.prototype.subscribeCommentAdded = function (resourceId, resourceType) {
        return this.commentAdded
            .asObservable()
            .pipe(filter(function (value) {
            return value &&
                value.resourceId === resourceId &&
                value.resourceType === resourceType;
        }));
    };
    CommentsService.prototype.subscribeCommentRemoved = function (resourceId, resourceType) {
        return this.commentRemoved
            .asObservable()
            .pipe(filter(function (value) {
            return value &&
                value.resourceId === resourceId &&
                value.resourceType === resourceType;
        }));
    };
    CommentsService.prototype.onAddComment = function () {
        if (this.values.value.length === 1) {
            this.commentAdded.next(this.resources);
        }
    };
    CommentsService.prototype.onRemoveComment = function () {
        if (this.values.value.length === 0) {
            this.commentRemoved.next(this.resources);
        }
    };
    Object.defineProperty(CommentsService.prototype, "resources", {
        get: function () {
            return {
                resourceId: this.resourceId$.value,
                resourceType: this.resource$.value
            };
        },
        enumerable: true,
        configurable: true
    });
    CommentsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommentsService_Factory() { return new CommentsService(i0.ɵɵinject(i1.HttpClient)); }, token: CommentsService, providedIn: "root" });
    return CommentsService;
}(CrudApiService));
export { CommentsService };
